module.exports = __webpack_public_path__ + "img/b1.3d5b35f0.png";